// 0028: founder-facing label resolver. Title takes precedence over
// idea so the dashboard / breadcrumbs / browser tab use the short
// LLM-authored name once it lands; pre-0028 products (and
// placeholder-state new products in their first ~9 minutes) fall
// back to the one-liner. Final fallback `Untitled idea` matches
// the backend PlaceholderTitle constant for wording consistency.
import type { RootName } from "./stripAnchors";

// The placeholder name a product carries until its first pass names it (models.PlaceholderTitle).
const UNTITLED = "Untitled idea";

type Named = {
  title?: string | null;
  idea?: string | null;
};

export function getDisplayName(p: Named | null | undefined): string {
  if (!p) return UNTITLED;
  return p.title?.trim() || p.idea?.trim() || UNTITLED;
}

// 0051 slice 3: the one rule for the founder's own idea under a heading that
// shows getDisplayName (the spec column's and the not-started page's): the
// idea line shows when the trimmed idea is non-empty and differs from the
// name the heading shows.
export function showsIdeaLine(p: Named | null | undefined): boolean {
  const idea = p?.idea?.trim() ?? "";
  return idea !== "" && idea !== getDisplayName(p);
}

// 0169 (Simon's ruling of 2026-10-13: the root reads as the product's name):
// what an anchor to the root whose label is the whole idea reads as, for
// stripAnchors. The name the heading shows (getDisplayName), when the product
// has one besides its idea and the placeholder; otherwise undefined, and the
// label shows as stored.
export function rootNameOf(p: Named | null | undefined): RootName | undefined {
  const idea = p?.idea?.trim() ?? "";
  const name = getDisplayName(p);
  if (!showsIdeaLine(p) || name === UNTITLED) return undefined;
  return { idea, name };
}
